<template>
    <v-dialog :value="dialog" max-width="400" :persistent="persistent">
        <v-card>
            <v-card-title class="headline"> {{ title }}
                <v-spacer></v-spacer>
                <v-btn icon @click="$emit('action', null)">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text v-html="text"></v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="d-inline">
                    <v-btn class="ma-0" text color="primary" @click="$emit('action', 1)">
                        {{ confirmButton }}
                    </v-btn>
                    <v-btn class="ma-0" text color="secondary" @click="$emit('action', 0)">
                        {{ cancelButton }}
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

   export default {
      name: 'confirm-prompt-dialog',
      props: {
         dialog: Boolean,
         persistent: Boolean,
         title: null,
         text: null,
         confirmButton: null,
         cancelButton: null
      }
   }
</script>
